import { makeStyles } from '@mui/styles';
import { body1 } from '../../shared/theme/text.styles';

export const useCUStyles = makeStyles((theme) => ({
  cuWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    paddingBottom: '170px',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'center',
      paddingBottom: '70px',
    },
  },

  mapWrapper: {
    width: '60%',
    height: '360px',
    overflow: 'hidden',

    [theme.breakpoints.down('lg')]: {
      width: '100%',
      margin: '0 auto',
      display: 'flex',
    },
  },

  address: {
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
      paddingTop: '40px',
      paddingBottom: '20px',
    },
  },

  contactDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',

    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },

    '& .MuiTypography-root': {
      ...body1,
    },
  },
}));
